<template lang="html">

  <section class="pe_game type-codecracker">
    
    <GameMenu />

    <div class="pe_container">

      <div class="pe_game-wrap">
        <Grid 
          type="codecracker"
        />
      </div>
      
      <ControlButtons />

    </div>
    
    <!-- <Adsense
      data-ad-client="ca-pub-4799626540510986"
      data-ad-slot="4304747998"
      data-ad-format="auto"
      data-full-width-responsive="true" 
      data-ad-test="on" 
    /> -->
    
    <transition name="delay">
      <CompletedModal 
        v-show="completed && !manuallyClosedModal"
        @CloseCompletedModal="closeCompModal"
      />
    </transition>



    <Notification />

  </section>

</template>


<script lang="js">

  import { mapActions, mapState } from 'vuex'

  import GameMenu from '@puzzleapps/shared/src/components/ui/GameMenu'
  import CompletedModal from '@puzzleapps/shared/src/components/ui/CompletedModal2'
  import Notification from '@puzzleapps/shared/src/components/ui/Notification'
  import ControlButtons from '@puzzleapps/codecracker/src/components/ControlButtons'
  import Grid from '@puzzleapps/codecracker/src/components/Grid'

  export default  {
    name: 'game',
    props: [],
    components: {
      Grid,
      CompletedModal,
      GameMenu,
      Notification,
      ControlButtons,
    },

    mounted() {
      this.selectThemeFromLocal()
      window.addEventListener('resize', this.responsiveKeyboardLayout)
    },

    data() {
      return {
        manuallyClosedModal: false,
      }
    },

    destroyed() {
      this.setIsPlaying(false)
      window.removeEventListener('resize', this.responsiveKeyboardLayout)
    },

    methods: {
      ...mapActions({
        setIsPlaying: 'game/setIsPlaying',
        selectThemeFromLocal: 'userSettings/selectThemeFromLocal',
        setInputAtPos: 'grid/setInputAtPos',
        /*selectNextLetter: 'grid/selectNextLetter',*/
        toggleIsAcross: 'grid/toggleIsAcross',
        responsiveKeyboardLayout: 'grid/responsiveKeyboardLayout',
      }),

      closeCompModal()
      {
          this.manuallyClosedModal = true;
      },

    },

    computed: {
      ...mapState({
        completed: state => state.game.completed,
        codeCrackerLetters: state => state.grid.codeCrackerLetters,
      }),
    },

}

</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/gameContainer';

  .pe_game {

    @media (max-width: 768px) {
      .simple-keyboard {
        width: 100%;
        padding: 15px;
      }
    }

    .pe_container {

      @media (max-width: 600px) {
        display: block;
        height: auto;
        padding-bottom: 0;
      }

      .pe_game-wrap {
        
        @media (max-width: 600px) {
          padding: 0;
          width: 100%;
        }
      }

    }
  }

</style>
